export default {
  push: function push(dataFn) {
    if (typeof dataLayer !== 'undefined') {
      var _dataFn;
      var gaProps = (_dataFn = dataFn(dataLayer)) === null || _dataFn === void 0 || (_dataFn = _dataFn.googleAnalytics) === null || _dataFn === void 0 ? void 0 : _dataFn.props;
      dataLayer.push(gaProps);
    }
  }
};